function snakeToCamel(str: string): string {
    return str.replace(/_([a-z])/g, (_, letter: string) => letter.toUpperCase());
}

function camelToSnake(str: string): string {
    return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
}

export function toSnakeCase(key: string): string {
    return camelToSnake(key);
}

export function toSnakeCaseObj<T = unknown>(obj: unknown): T {
    if (obj === null || obj === undefined) return obj as T;
    if (Array.isArray(obj)) return obj.map(toSnakeCaseObj) as T;
    if (typeof obj !== "object") return obj as T;
    if (obj instanceof Date) return obj as T;

    const result: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(obj)) {
        result[camelToSnake(key)] = toSnakeCaseObj(value);
    }
    return result as T;
}

export function toCamelCase<T = unknown>(obj: unknown): T {
    if (obj === null || obj === undefined) return obj as T;
    if (Array.isArray(obj)) return obj.map(toCamelCase) as T;
    if (typeof obj !== "object") return obj as T;
    if (obj instanceof Date) return obj as T;

    const result: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(obj)) {
        result[snakeToCamel(key)] = toCamelCase(value);
    }
    return result as T;
}
